<!-- main content start -->
<div class="main-content">
  <div class="row g-4">
    <div class="col-12">
      <div class="panel">
        <div class="panel-header">
          <h5 class="fw-bold">All Order</h5>
        </div>

        <div class="panel-body">
          <div class="table-responsive">
            <table
              class="table table-dashed table-hover digi-dataTable all-product-table table-striped"
              id="allProductTable"
            >
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th class="text-start" style="width: 250px;">Product</th>
                  <th>Price</th>
                  <th>Payment Method</th>
                  <th>Order Date</th>
                  <th class="position-sticky end-0 z-3 text-center" style="min-width: 200px;">
                    Action & Status
                  </th>
                </tr>
              </thead>

              <tbody>
                @for (order of orderListData?.data; track $index) {
                  <tr>
                    <td>{{ order.id }}</td>
                    <td>{{ getCustomerName(order) }}</td>
                    <td class="text-start">{{ getPrimaryProductTitle(order) }}</td>
                    <td>{{ order.total_amount }}</td>
                    <td>{{ order.payment_method }}</td>
                    <td>{{ order.created_at | date:'dd MMM yyyy, hh:mm a' }}</td>
                    <td class="position-sticky end-0 z-3 bg-white shadow-sm">
                      <div class="d-flex align-items-center gap-2">
                        <select
                          class="form-select form-select-sm"
                          style="width: 150px;"
                          [ngModel]="order.status"
                          (ngModelChange)="updateStatus(order, $event, order.status)"
                        >
                          @for (status of allStatuses; track $index) {
                            <option [value]="status.value" [disabled]="!isStatusAllowed(order, status.value)">
                              {{ status.label }}
                            </option>
                          }
                        </select>

                        <button
                          type="button"
                          class="btn text-danger p-0 border-0 bg-transparent"
                          title="View Order"
                          aria-label="View order details"
                          (click)="viewOrder(order)"
                        >
                          <i class="fa fa-eye"></i>
                        </button>

                        <button
                          type="button"
                          class="btn text-primary p-0"
                          title="Download Invoice"
                          (click)="downloadInvoice(order)"
                        >
                          <i class="fa fa-file-invoice"></i>
                        </button>

                        <button
                          type="button"
                          class="btn text-success p-0"
                          title="Download Payslip"
                          (click)="downloadPaySlip(order)"
                        >
                          <i class="fa fa-download"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div class="d-flex align-items-center justify-content-end gap-1 py-2">
            @for (page of orderListData?.links; track $index) {
              <button type="button" class="btn" (click)="nextPage(page.page)">
                <span [innerHTML]="page.label"></span>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <p>
      Copyright&copy;
      <script>document.write(new Date().getFullYear())</script>
      All Rights Reserved By <span class="text-primary">Safure</span>
    </p>
  </div>
</div>
<!-- main content end -->
